// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","shlyapa":"T4ldFz_J"};